import React, { useState,useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVideoCamera, faTimes, faPlus } from "@fortawesome/free-solid-svg-icons";
import "./photopage.css";
import { getCrewReels, submitActorReels } from "../../api/axios";
import { getActorReels } from "../../api/axios";
import { updateActorReels } from "../../api/axios";
import Alert from "../common/Alert";
import { submitCrewReels } from "../../api/axios";
import { Button } from "@mui/material";

const VideoPage = ({userDetails,GetUserDetails}) => {
  const id = userDetails.registerResult.id;

  const [hasReels, setHasReels] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [alertMessage, setAlertMessage] = useState("");

  const [videoLinks, setVideoLinks] = useState({
    demoReel: "",
    slate: "",
    ugcDemoReel: "",
  });

  const [inputValues, setInputValues] = useState({
    demoReel: "",
    slate: "",
    ugcDemoReel: "",
  });

  //GET actor reels
  const GetActorReels = async (id) =>{
    const role = userDetails.registerResult.role;
    try {

      if(role ==="actor"){
        const res = await getActorReels(id);
        if(res.status){
          SetReelsLinks(res)
        }
      }else if(role ==="crew"){
        const res = await getCrewReels(id);
        if(res.status){
          SetReelsLinks(res)
        }
      }
      
    } catch (error) {
      // console.log("error fetching reels", error);
    }
  }

  const SetReelsLinks =(res)=>{
    const reelsExist = res.result.demoReel || res.result.slate || res.result.ugcDemoReal;
        setHasReels(!!reelsExist);

        setInputValues({
          demoReel: res.result.demoReel,
          slate: res.result.slate,
          ugcDemoReel: res.result.ugcDemoReal,
        });

        setVideoLinks({
          demoReel: res.result.demoReel,
          slate: res.result.slate,
          ugcDemoReel: res.result.ugcDemoReal,
        });
  }

   useEffect(() => {
      GetActorReels(id);
    }, []);

  const getEmbedUrl = (url) => {

    //* Check for YouTube links
    const youtubeMatch = url.match(
    /(?:youtube\.com.*[?&]v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/shorts\/)([a-zA-Z0-9_-]{11})/
  );
  if (youtubeMatch) {
    return `https://www.youtube.com/embed/${youtubeMatch[1]}?rel=0&modestbranding=1&controls=0&showinfo=0&disablekb=1&fs=0`;
  }

    //* Check for Google Drive links
    const driveMatch = url.match(/drive\.google\.com\/file\/d\/([a-zA-Z0-9_-]+)\/view/);
    if (driveMatch) {
      return `https://drive.google.com/file/d/${driveMatch[1]}/preview`;
    }

    return url; 
  };

  const handleInputChange = (event, type) => {
    const url = event.target.value;
    setInputValues((prev) => ({
      ...prev,
      [type]: url,
    }));
  };

  const handleAddVideo = (type) => {
    const url = inputValues[type];
    if (!url) return;

    setVideoLinks((prev) => ({
      ...prev,
      [type]: getEmbedUrl(url),
    }));
  };

  const handleRemove = (type) => {
    setVideoLinks((prev) => ({
      ...prev,
      [type]: "",
    }));

    setInputValues((prev) => ({
      ...prev,
      [type]: "",
    }));
  };


  const UpdateActorReels = async ()=>{
    const role = userDetails.registerResult.role;
    if(role === 'crew'){
      try {
        const res =await submitCrewReels({
          crew_id:id,
          demoReel: videoLinks.demoReel,
          slate: videoLinks.slate,
          ugcDemoReal: videoLinks.ugcDemoReel,
        }
        );

        if(res.status){
          // console.log("Reels updated successfully.");
          setAlertSeverity("success");
          setAlertMessage("Your reels updated successfully");
          setOpenSnackbar(true);
        }
      } catch (error) {
        // console.log("Error updating user reels",error);
        setAlertSeverity("error");
        setAlertMessage(error.message || "Error submitting reels")
        setOpenSnackbar(true);
      }

    }else if(role === 'actor'){
      try {
        const res =await submitActorReels({
          demoReel: videoLinks.demoReel,
          slate: videoLinks.slate,
          ugcDemoReal: videoLinks.ugcDemoReel,
          actor_id:userDetails.registerResult.id
        }
        );
        if(res.status){
          // console.log("Reels updated successfully.");
          setAlertSeverity("success");
          setAlertMessage("Your reels updated successfully");
          setOpenSnackbar(true);
        }
      } catch (error) {
        // console.log("Error updating user reels",error);
        setAlertSeverity("error");
        setAlertMessage(error);
        setOpenSnackbar(true);
      }
    }
    
  }

  return (
    <div className="log-profile-video-info">
      <div className="log-video-title">Videos:</div>
      <div className="log-video-section">
        {Object.entries(videoLinks).map(([key, value]) => (
          <div className="log-video-box-card" key={key}>
            <div className="log-video-box">
              {value ? (
                <>
                  <iframe
                    width="100%"
                    height="200"
                    src={value}
                    title="Video Preview"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <button className="remove-video-btn" onClick={() => handleRemove(key)}>
                    <FontAwesomeIcon icon={faTimes} /> Remove
                  </button>
                </>
              ) : (
                <>
                  <FontAwesomeIcon
                    icon={faVideoCamera}
                    className="log-video-upload-icon"
                  />
                  <div className="video-link-btn-container">
                  <input
                    type="text"
                    placeholder="Paste video link"
                    className="video-url-input"
                    value={inputValues[key]}
                    onChange={(e) => handleInputChange(e, key)}
                  />
                  <button className="add-video-btn" onClick={() => handleAddVideo(key)}>
                    Preview
                  </button>
                  </div>
                </>
              )}
            </div>
            <div className="video-label">Demo Reels</div>
          </div>
        ))}
      </div>

        {/* <button className="video-link-submit-btn" onClick={UpdateActorReels}>
          Update Your Reels
        </button> */}
        <Button sx={{marginTop: 2}} variant="contained" onClick={UpdateActorReels}>
        Update Your Reels
        </Button>
        
        <Alert
        openSnackbar={openSnackbar}
        alertSeverity={alertSeverity}
        setOpenSnackbar={setOpenSnackbar}
        alertMessage={alertMessage}
      />
    </div>
  );
};
export default VideoPage;
